import React from "react";
import { graphql } from "gatsby";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";
import { GatsbyImage } from "gatsby-plugin-image";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

import * as styles from "../styles/landing-page.module.css";

const LandingPageTemplate = ({ data }) => {
  if (!data) return null;

  const { title, image } = data.prismicLandingPage.data || {};
  const topMenu = data.prismicTopMenu || {};
  const footerData = data.prismicFooter || {};

  return (
    <Layout topMenu={topMenu?.data || {}} footerData={footerData?.data || {}}>
      <div data-color-scheme="black" className={styles.container}>
        {title && <h1 className="visually-hidden text-center">{title.text}</h1>}
        {image && <GatsbyImage image={image.gatsbyImageData} alt={image.alt} className={styles.image}/>}
      </div>
    </Layout>
  );
};

export const Head = ({ data }) => {
  const pageTitle = `Doing Things | ${
    data?.prismicLandingPage?.data?.title?.text || "Landing Page"
  }`;
  return <Seo title={pageTitle} />;
};

export const query = graphql`
  query landingPageQuery($id: String!) {
    prismicLandingPage(id: { eq: $id }) {
      _previewable
      data {
        title {
          text
        }
        image {
          gatsbyImageData(placeholder: BLURRED)
          alt
        }
      }
    }
    prismicTopMenu {
      ...TopMenuFragment
    }
    prismicFooter {
      ...FooterFragment
    }
  }
`;

export default withPrismicPreview(LandingPageTemplate);
